<template>
  <div class="score-mgn-page">
    <!-- 筛选区 -->

    <div class="filter-bar">
      <el-form :inline="true" :model="filter" size="medium" label-width="auto">
        <el-form-item label="部门">
          <el-cascader
            v-model="filter.orgIdList"
            :options="optionsDepartment"
            :props="defaultProps1"
            clearable
            filterable
            collapse-tags
            placeholder="请选择部门"
          ></el-cascader>
        </el-form-item>

        <el-form-item label="职级">
          <el-select
            v-model="filter.empRankList"
            placeholder="请选择职级"
            clearable
            filterable
            multiple
          >
            <el-option
              v-for="item in optionsRank"
              :key="item.id"
              :label="item.title"
              :value="item.id"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="手机号">
          <el-input
            v-model="filter.phone"
            placeholder="请输入手机号"
            clearable
          />
        </el-form-item>
        <el-form-item label="姓名">
          <el-input
            v-model="filter.empName"
            placeholder="请输入姓名"
            clearable
          />
        </el-form-item>

        <el-form-item label="工号">
          <el-input v-model="filter.empNo" placeholder="请输入工号" clearable />
        </el-form-item>

        <el-form-item label="积分状态">
          <el-select v-model="filter.states" placeholder="请选择状态" clearable>
            <el-option label="开启" value="0" />
            <el-option label="关闭" value="1" />
          </el-select>
        </el-form-item>
        <el-form-item label="员工状态">
          <el-select
            v-model="filter.disabled"
            placeholder="请选择状态"
            clearable
          >
            <el-option label="在职" value="0" />
            <el-option label="离职" value="1" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="resetQuery">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 工具栏 -->
    <div class="table-toolbar">
      <el-button type="warning" size="small" @click="handleAdjustScore"
        >批量调整积分</el-button
      >
      <el-button
        type="danger"
        size="small"
        @click="batchFreeze"
        :disabled="selectedEmpNos.length == 0"
        >关闭</el-button
      >
      <el-button
        type="success"
        size="small"
        @click="batchUnfreeze"
        :disabled="selectedEmpNos.length == 0"
        >开启</el-button
      >
      <el-button type="success" class="export-btn" @click="exportData"
        >导出</el-button
      >
    </div>

    <!-- 主表格 -->
    <el-table
      ref="table"
      :data="tableData"
      border
      style="width: 100%"
      @selection-change="handleSelectionChange"
      v-loading="tableLoading"
    >
      <el-table-column type="selection" width="55" align="center" />
      <el-table-column prop="empNo" label="工号" align="center" min-width="80">
        <template slot-scope="{ row }">
          <span class="emp-no" @click="openScoreRecordDialog(row)">{{
            row.empNo
          }}</span>
        </template>
      </el-table-column>

      <el-table-column prop="emoName" label="姓名" align="center" min-width="80"/>
      <el-table-column prop="phone" label="手机号" align="center" min-width="80">
        <template slot-scope="scope">
          <span v-if="isHighRank(scope.row.empRankCode)">
            {{ maskPhone(scope.row.phone) }}
          </span>
          <span v-else>
            {{ scope.row.phone || '-' }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="empRankCode" label="职级" align="center" min-width="80"/>
      <el-table-column
        prop="boardDate"
        label="入职时间"
        align="center"
        min-width="80"
      >
        <template slot-scope="{ row }">
          <span>{{
            row.boardDate ? moment(row.boardDate).format("YYYY-MM-DD") : "-"
          }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="gender" label="性别" align="center"  min-width="60">
        <template slot-scope="{ row }">
          <span>{{
            row.gender == 760 ? "男" : row.gender == 761 ? "女" : ""
          }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="orgName"
        label="所属部门"
        align="center"
        min-width="180"
      />
      <el-table-column
        prop="totalPoints"
        label="累计积分"
        align="center"
        sortable
        min-width="100"

      />
      <el-table-column
        prop="availablePoints"
        label="未同步积分"
        align="center"
        sortable
        min-width="120"
      />
      <el-table-column
        prop="updatedAt"
        label="修改时间"
        align="center"
        min-width="120"
      />
      <el-table-column label="是否可用" align="center" min-width="80">
        <template slot-scope="{ row }">
          <el-switch
            v-model="row.userPointStates"
            active-value="0"
            inactive-value="1"
            @change="handleSingleFreeze(row)"
          />
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" min-width="100">
        <template slot-scope="scope" >
          <div style="display:flex">
              <!-- 调整积分 -->
          <el-button
            type="success"
            size="small"
            @click="handleSingleAdjust(scope.row)"
            icon="el-icon-edit"
          >
          </el-button>
          <!-- 积分记录 -->
          <el-button
            type="success"
            size="small"
            @click="openScoreRecordDialog(scope.row)"
            icon="el-icon-s-order"
          >
          </el-button>
          </div>
        
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <el-pagination
      class="pagination"
      background
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      :current-page="pageData.page"
      :page-sizes="[10, 200, 500]"
      :page-size="pageData.pageSize"
      @size-change="handleSizeChange"
      @current-change="handlePageChange"
    />

    <!-- 积分记录弹窗 -->
    <el-dialog
      title="积分记录"
      :visible.sync="scoreRecordDialogVisible"
      width="90%"
      append-to-body
    >
      <div class="record-header">
        <span class="info-item"
          >姓名：{{ currentUserInfo.emoName || "-" }}</span
        >
        <span class="info-item">工号：{{ currentUserInfo.empNo || "-" }}</span>
        <span class="info-item"
          >职级：{{ currentUserInfo.empRankCode || "-" }}</span
        >
        <span class="info-item"
          >部门：{{ currentUserInfo.orgName || "-" }}</span
        >
        <span class="info-item"
          >总积分：{{ currentUserInfo.totalPoints || 0 }}</span
        >
      </div>

      <el-table
        :data="scoreRecordList"
        border
        max-height="600"
        style="width: 100%"
        :loading="recordLoading"
      >
        <el-table-column
          prop="createdAt"
          label="时间"
          align="center"
          width="180"
        >
          <template slot-scope="scope">
            {{
              scope.row.createdAt
                ? moment(scope.row.createdAt).format("YYYY-MM-DD HH:mm:ss")
                : ""
            }}
          </template>
        </el-table-column>
        <el-table-column
          prop="totalPoints"
          label="积分余额"
          align="center"
          min-width="100"
        />
        <el-table-column
          prop="points"
          label="积分变动"
          align="center"
          min-width="100"
        >
          <template slot-scope="scope">
            <span
              :style="{ color: scope.row.points > 0 ? '#F56C6C' : '#67C23A' }"
            >
              {{
                scope.row.points > 0 ? "+" + scope.row.points : scope.row.points
              }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="description"
          label="积分来源记录"
          align="center"
          min-width="200"
          show-overflow-tooltip
        />
        <el-table-column
          prop="remark"
          label="备注"
          align="center"
          min-width="120"
        />
        <el-table-column
          prop="createBy"
          label="操作人"
          align="center"
          min-width="100"
        />
      </el-table>

      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="scoreRecordTotal"
        :current-page="recordPageData.page"
        :page-size="recordPageData.pageSize"
        @current-change="handleRecordPageChange"
        @size-change="handleRecordSizeChange"
        style="text-align: right; margin-top: 16px"
      />
    </el-dialog>

    <!-- 调整积分弹窗 -->
    <el-dialog
      title="调整积分"
      :visible.sync="adjustScoreDialogVisible"
      width="600px"
      top="10vh"
      append-to-body
      @close="closeAdjust"
    >
      <!-- 加了 :rules 和 ref -->
      <el-form
        :model="adjustScoreForm"
        :rules="rules"
        ref="adjustForm"
        label-width="100px"
        style="padding: 10px 20px"
      >
        <el-form-item label="积分来源" prop="sourceTypeId">
          <el-select
            v-model="adjustScoreForm.sourceTypeId"
            placeholder="请选择积分来源"
            style="width: 250px"
            clearable
            @change="handleSourceChange"
          >
            <el-option
              v-for="item in optionsSourceType"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="调整积分" prop="points">
          <el-input
            v-model.number="adjustScoreForm.points"
            type="number"
            placeholder="请输入积分"
            style="width: 250px"
          />
          <span style="margin-left: 10px; font-weight: bold">
            <span v-if="adjustScoreForm.direction == 1" style="color: #67c23a"
              >+ 增加积分</span
            >
            <span
              v-else-if="adjustScoreForm.direction == -1"
              style="color: #f56c6c"
              >- 消耗积分</span
            >
          </span>
        </el-form-item>

        <el-form-item label="调整说明" prop="remark">
          <el-input
            v-model="adjustScoreForm.remark"
            type="textarea"
            :rows="3"
            placeholder="请输入调整原因"
          />
        </el-form-item>
      </el-form>

      <div slot="footer">
        <el-button @click="closeAdjust">取消</el-button>
        <el-button type="success" @click="submitAdjust" :loading="loading"
          >提交</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import moment from "moment";
import api from "@/apis/medal";
import { getToken } from "@/utils/cookie";

export default {
  name: "ScoreMgn",
  data() {
    return {
      optionsDepartment: [],
      defaultProps1: {
        multiple: true,
        children: "child",
        value: "id",
        label: "departmentName",
        emitPath: false,
        // checkStrictly: true,
      },
      moment,
      filter: {
        orgId: null,
        phone: "",
        empRankList: [],
        states: null,
        sortType: "",
        disabled: "0",
      },
      pageData: { page: 1, pageSize: 10 },
      total: 0,
      tableData: [],
      tableLoading: false,
      selectedRows: [],
      scoreRecordDialogVisible: false,
      currentUserInfo: {},
      scoreRecordList: [],
      scoreRecordTotal: 10,
      recordPageData: { page: 1, pageSize: 20 },
      recordLoading: false,

      // 积分调整
      adjustScoreDialogVisible: false,
      loading: false,
      adjustScoreForm: {
        sourceTypeId: "",
        direction: "",
        points: null,
        description: null,
        remark: "",
      },
      optionsSourceType: [],
      optionsRank: [],

      rules: {
        sourceTypeId: [
          { required: true, message: "请选择积分来源", trigger: "change" },
        ],
        points: [
          { required: true, message: "请输入调整积分", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              if (!value || value <= 0) {
                callback(new Error("积分必须大于0"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        remark: [
          { required: true, message: "请输入调整说明", trigger: "blur" },
        ],
      },
    };
  },
  computed: {
    selectedEmpNos() {
      return this.selectedRows.map((row) => row.empNo);
    },
  },
  watch: {
    adjustScoreDialogVisible: {
      handler: function (val) {
        if (val == true) {
          this.getSourceList();
        }
      },
      immediate: false,
      deep: true,
    },
  },
  mounted() {
    this.queryData();
    this.getDepartmentList();
    this.getRankList();
  },
  methods: {
    // 判断是否是 M6 及以上职级
    isHighRank(rankCode) {
      if (!rankCode) return false;
      const rankMap = {
        'M1': 1, 'M2': 2, 'M3': 3, 'M4': 4, 'M5': 5, 'M6': 6,
        'M7': 7, 'M8': 8, 'M9': 9, 'M10': 10,
        'O1': 1, 'O2': 2, 'O3': 3, 'O4': 4, 'O5': 5, 'O6': 6,
        'O7': 7, 'O8': 8, 'O9': 9, 'O10': 10
      };
      const rankValue = rankMap[rankCode.toUpperCase()];
      return rankValue >= 6;
    },

    // 手机号脱敏
    maskPhone(phone) {
      if (!phone) return '-';
      const phoneStr = phone.toString();
      if (phoneStr.length < 11) return phoneStr;
      return phoneStr.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2');
    },

    // 积分记录分页 - 页大小改变
    handleRecordSizeChange(val) {
      this.recordPageData.pageSize = val;
      this.recordPageData.page = 1; // 切换条数时回到第一页
      this.queryScoreRecord(this.currentUserInfo.empNo);
    },

    handleSearch() {
      this.pageData.page = 1;
      this.queryData();
    },
    resetQuery() {
      this.pageData.page = 1;
      this.pageData.pageSize = 10;
      this.filter = {
        orgIdList: [],
        phone: "",
        empRankList: [],
        states: null,
        sortType: "",
        disabled: "0",
      };
      this.queryData();
    },
    handleSizeChange(val) {
      this.pageData.pageSize = val;
      this.pageData.page = 1;
      this.queryData();
    },
    getRankList() {
      api.getPositionLevel({ type: "EmpRank" }).then((res) => {
        if (res.code == 200) {
          this.optionsRank = res.data || [];
        }
      });
    },
    getDepartmentList() {
      api.findListByName().then((data) => {
        if (data.code == 200) {
          this.optionsDepartment = data.data || [];
        }
      });
    },
    getSourceList() {
      api
        .getPointSet({ page: 1, pageSize: 99999, isActive: 1 })
        .then((res) => {
          this.optionsSourceType = res.data?.list || [];
        })
        .catch((err) => {});
    },
    handleSourceChange(val) {
      const item = this.optionsSourceType.find((i) => i.id == val);
      if (item) {
        this.adjustScoreForm.direction = item.direction;
        this.adjustScoreForm.description = item.description;
      } else {
        this.adjustScoreForm.direction = "";
        this.adjustScoreForm.description = "";
      }
    },

    closeAdjust() {
      this.$refs.adjustForm.resetFields();
      this.adjustScoreDialogVisible = false;
    },
    async submitAdjust() {
      this.$refs.adjustForm.validate(async (valid) => {
        if (!valid) return;

        this.loading = true;
        const { sourceTypeId, direction, points, remark, description } =
          this.adjustScoreForm;

        try {
          const adjustPointsList = this.selectedRows.map((item) => ({
            empNo: item.empNo,
            points: direction == 1 ? points : -points,
            sourceTypeId,
            remark,
            creatBy: getToken(),
            description,
          }));

          await api.adjustUserPoints({ adjustPointsList });
          this.$message.success("调整成功");
          this.adjustScoreDialogVisible = false;
          this.$refs.adjustForm.resetFields();
          this.queryData();
        } catch (err) {
          this.$message.error("调整失败");
        } finally {
          this.loading = false;
        }
      });
    },

    async queryData() {
      try {
        this.tableLoading = true;
        const params = {
          page: this.pageData.page,
          pageSize: this.pageData.pageSize,
          ...this.filter,
        };

        Object.keys(params).forEach((key) => {
          if (
            params[key] == "" ||
            params[key] == null ||
            (Array.isArray(params[key]) && params[key].length === 0)
          )
            delete params[key];
        });

        const res = await api.getPointMgn(params);
        this.tableData = res.data?.list || [];
        this.total = res.data?.total || 0;
      } catch (error) {
        this.$message.error("查询失败");
      } finally {
        this.tableLoading = false;
      }
    },
    handleSelectionChange(val) {
      this.selectedRows = val;
    },
    async handleSingleFreeze(row) {
      const targetState = row.userPointStates;
      const msg =
        targetState == "0"
          ? "开启后该用户积分可正常使用，确定要开启吗？"
          : "关闭后该用户积分将无法使用，确定要关闭吗？";

      this.$confirm(msg, "操作确认", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: targetState == "0" ? "success" : "warning",
      })
        .then(async () => {
          try {
            await api.updateUserPointStatus({
              empNoList: [row.empNo],
              states: targetState,
            });
            this.$message.success(targetState == "0" ? "开启成功" : "关闭成功");
          } catch (e) {
            this.$message.error("操作失败");
            row.userPointStates = targetState == "0" ? "1" : "0";
          }
        })
        .catch(() => {
          row.userPointStates = targetState == "0" ? "1" : "0";
        });
    },
    async batchFreeze() {
      if (!this.selectedEmpNos.length) return;
      this.$confirm(
        "关闭后选中用户积分将无法使用，确定要关闭选中用户吗？",
        "操作确认",
        {
          confirmButtonText: "确定关闭",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(async () => {
          await api.updateUserPointStatus({
            empNoList: this.selectedEmpNos,
            states: 1,
          });
          this.$message.success("批量关闭成功");
          this.queryData();
        })
        .catch(() => {
          this.$message.info("已取消关闭");
        });
    },
    async batchUnfreeze() {
      if (!this.selectedEmpNos.length) return;
      this.$confirm(
        "开启后选中用户积分可正常使用，确定要开启选中用户吗？",
        "操作确认",
        {
          confirmButtonText: "确定开启",
          cancelButtonText: "取消",
          type: "success",
        }
      )
        .then(async () => {
          await api.updateUserPointStatus({
            empNoList: this.selectedEmpNos,
            states: 0,
          });
          this.$message.success("批量开启成功");
          this.queryData();
        })
        .catch(() => {
          this.$message.info("已取消开启");
        });
    },
    //单行调整积分
    // 单行调整积分
    handleSingleAdjust(row) {
      this.selectedRows = [row]; // 只选当前行
      this.adjustScoreForm = {
        sourceTypeId: "",
        direction: "",
        points: null,
        remark: "",
      };
      this.adjustScoreDialogVisible = true;
    },
    handleAdjustScore() {
      if (this.selectedRows.length == 0) {
        this.$message.warning("请先选择用户");
        return;
      }

      this.adjustScoreForm = {
        sourceTypeId: "",
        direction: "",
        points: null,
        remark: "",
      };
      this.adjustScoreDialogVisible = true;
    },
    exportData() {
      if (!this.selectedEmpNos.length) {
        this.$message.warning("请先选择要导出的数据");
        return;
      }
      this.$message.success("导出功能开发中...");
    },
    handlePageChange(page) {
      this.pageData.page = page;
      this.queryData();
    },
    openScoreRecordDialog(row) {
      this.currentUserInfo = { ...row };
      this.recordPageData.page = 1;
      this.queryScoreRecord(row.empNo);
      this.scoreRecordDialogVisible = true;
    },

    // 积分记录接口
    async queryScoreRecord(empNo) {
      try {
        this.recordLoading = true;
        const json = {
          page: this.recordPageData.page,
          pageSize: this.recordPageData.pageSize,
          empNo: empNo,
        };
        const res = await api.scoreRecordListApi(json);
        this.scoreRecordList = res.data?.list || [];
        this.scoreRecordTotal = res.data?.total || 0;
      } catch (error) {
        this.$message.error("查询积分记录失败");
      } finally {
        this.recordLoading = false;
      }
    },
    handleRecordPageChange(page) {
      this.recordPageData.page = page;
      this.queryScoreRecord(this.currentUserInfo.empNo);
    },
  },
};
</script>

<style lang="scss" scoped>
.score-mgn-page {
  background: #fff;
  padding: 20px;
  min-height: calc(100vh - 120px);

  .filter-bar {
    padding: 16px;
    background: #fafbfc;
    border-radius: 8px;
    margin-bottom: 20px;
  }

  .table-toolbar {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 10px;
    .export-btn {
      margin-left: auto;
    }
  }

  .pagination {
    margin-top: 20px;
    text-align: right;
  }

  .record-header {
    padding: 10px 15px;
    background: #f5f7fa;
    border-radius: 4px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 30px;
  }

  .like-icon {
    cursor: pointer;
    color: #999;
    transition: color 0.2s;
    &.liked {
      color: #ff9f00 !important;
    }
  }
}
.user-info {
  display: flex;
  margin-bottom: 20px;
}

.record-header {
  padding: 12px 20px;
  background: #f5f7fa;
  border-radius: 4px;
  margin-bottom: 20px;
}
::v-deep .info-item {
  display: inline-block;
  margin-right: 25px;
  line-height: 28px;
}
.emp-no {
  cursor: pointer;
  color: #1fbe8a;
}
</style>
